import { createAction, props } from '@ngrx/store';

import {
  CovidAssessmentDocCreateRequest,
  CovidAssessmentDocUpdateRequest,
  DocRenameRequest,
  DocumentDuplicateResponse,
  WorkspaceItem,
  WorkspaceMoveRequest
} from '@primatoo-ms-organization';
import { ValidateDocumentRequest } from 'it/primatoo/openapi/api/org/schemas/common/docs/ValidateDocumentRequest';
import { UiDocumentItem } from '@pt/pt-models';
import { UpdateDocResponse } from 'it/primatoo/openapi/api/org/schemas/common/docs/UpdateDocResponse';


// COVID ASSESSMENT

export const createCovidAssessment = createAction('[CovidAssessment] Create CovidAssessment', props<{
  request: CovidAssessmentDocCreateRequest
}>());
export const createCovidAssessmentSuccess = createAction('[CovidAssessment] Create CovidAssessment Success', props<{
  id: number
}>());
export const createCovidAssessmentFailed = createAction('[CovidAssessment] Create CovidAssessment Failed', props<{
  error: any
}>());

export const updateCovidAssessment = createAction('[CovidAssessment] Update Covid Assessment', props<{
  id: number,
  request: CovidAssessmentDocUpdateRequest
}>());
export const updateCovidAssessmentSuccess = createAction('[CovidAssessment] Update Covid Assessment Success', props<{
  response: UpdateDocResponse
}>());
export const updateCovidAssessmentFailed = createAction('[CovidAssessment] Update Covid Assessment Failed', props<{
  error: any
}>());

export const renameCovidAssessment = createAction('[folder] Rename Covid Assessment', props<{
  id: number,
  request: DocRenameRequest
}>());
export const renameCovidAssessmentSuccess = createAction('[folder] Rename Covid Assessment Success', props<{
  id: number
}>());
export const renameCovidAssessmentFailed = createAction('[folder] Rename Covid Assessment Failed', props<{
  error: any
}>());

export const publishCovidAssessmentWithConfirm = createAction('[CovidAssessment] Publish Covid Assessment with confirm', props<{
  docId: number,
  skipBack?: boolean,
  hideInfo?: boolean
}>());
export const publishCovidAssessment = createAction('[CovidAssessment] Publish Covid Assessment', props<{
  docId: number,
  skipBack?: boolean
}>());
export const publishCovidAssessmentSuccess = createAction('[CovidAssessment] Publish Covid Assessment Success');
export const publishCovidAssessmentFailed = createAction('[CovidAssessment] Publish Covid Assessment Failed', props<{
  error: any
}>());

export const moveCovidAssessment = createAction('[CovidAssessment] Move CovidAssessment',
  props<{ id: number, workspaceMoveRequest: WorkspaceMoveRequest }>());
export const moveCovidAssessmentSuccess = createAction('[CovidAssessment] Move CovidAssessment Success', props<{
  item: WorkspaceItem
}>());
export const moveCovidAssessmentFailed = createAction('[CovidAssessment] Move CovidAssessment Failed', props<{
  error: any
}>());

export const duplicateCovidAssessment = createAction('[CovidAssessment] Duplicate CovidAssessment', props<{
  id: number,
  request: CovidAssessmentDocCreateRequest
}>());
export const duplicateCovidAssessmentSuccess = createAction('[CovidAssessment] Duplicate CovidAssessment success', props<{
  response: DocumentDuplicateResponse
}>());
export const duplicateCovidAssessmentFailed = createAction('[CovidAssessment] Duplicate CovidAssessment failed', props<{
  error: any
}>());

export const deleteCovidAssessment = createAction('[CovidAssessment] Delete CovidAssessment', props<{ id: number }>());
export const deleteCovidAssessmentSuccess = createAction('[CovidAssessment] Delete CovidAssessment Success');
export const deleteCovidAssessmentFailed = createAction('[CovidAssessment] Delete CovidAssessment Failed', props<{
  error: any
}>());

export const reopenCovidAssessmentWithConfirm = createAction('[CovidAssessment] Reopen CovidAssessment with confirm', props<{
  id: number
}>());
export const reopenCovidAssessment = createAction('[CovidAssessment] Reopen CovidAssessment', props<{ id: number }>());
export const reopenCovidAssessmentSuccess = createAction('[CovidAssessment] Reopen CovidAssessment Success', props<{
  id: number
}>());
export const reopenCovidAssessmentFailed = createAction('[CovidAssessment] Reopen CovidAssessment Failed', props<{
  error: any
}>());

export const validateCovidAssessmentWithConfirm = createAction('[CovidAssessment] Validate document with confirm', props<{
  document: UiDocumentItem,
  skipBack?: boolean
}>());
export const validateCovidAssessment = createAction('[CovidAssessment] Validate document',
  props<{ document: UiDocumentItem, request: ValidateDocumentRequest, skipBack?: boolean }>());
export const validateCovidAssessmentSuccess = createAction('[CovidAssessment] Validate document Success');
export const validateCovidAssessmentFailed = createAction('[CovidAssessment] Validate document Failed', props<{
  error: any
}>());
export const createSnapshotSuccess = createAction('[CovidAssessment] Create Snapshot Success');
